import React from 'react';
import Jersey from '../../common/jerseys/Jersey';

function LiveMatchHeader(props) {
    return (
        <div className="info-evento-centrale d-flex justify-content-around align-items-center">
            <div className="d-flex items-center">
                <Jersey className="xs_jersey_medium" data={props.jerseys?.[0]} type={'home'} sportRef={props.sportRef} />
                <div className="squadra-evento squadra-casa">
                    {props.team1}
                </div>
            </div>
            <div className="punteggio-evento-centrale allinea-centro">
                <div className="riga grassetto">{props.team1Score}<span className="trattino">:</span>{props.team2Score}</div>
                {props.score.currentMinute &&
                    <div className="riga colore-1 lampeggia">{props.score.currentMinute}</div>
                }
            </div>
        
            <div className="d-flex items-center">
                <div className="squadra-evento squadra-trasferta">
                    {props.team2}
                </div>
                <Jersey className="xs_jersey_medium" data={props.jerseys?.[1]} type={'away'} sportRef={props.sportRef} />
            </div>
        </div>
    );
}

export default LiveMatchHeader;
